module.exports = __webpack_public_path__ + "static/fipclilacrain3-24f8f70615c7bddad790d02798bc8fbe.jpeg";